import SpeedDialSrc from './components/speed-dial/speed-dial';
import BubbleListSrc from './components/bubble-list/bubble-list';
import BubbleListItemSrc from './components/bubble-list-item/bubble-list-item';

export const SpeedDial = SpeedDialSrc;
export const BubbleList = BubbleListSrc;
export const BubbleListItem = BubbleListItemSrc;



/** WEBPACK FOOTER **
 ** ./src/speed-dial.js
 **/